<template>
  <div v-show="helpMenu.length > 0">
    <sl-dropdown
      ref="dropdownMenu"
      placement="bottom-end"
      distance="10"
      skidding="-10"
      :disabled="!helpMenu"
      hoist
    >
      <Trigger slot="trigger">
        <PhQuestion weight="bold" size="1.2em" role="presentation" />
      </Trigger>
      <div
        class="py-4 min-w-96 rounded-[--sl-border-radius-medium] bg-white max-h-[90vh] overflow-auto"
      >
        <HelpCategory
          v-for="(category, index) in helpMenu"
          :key="index"
          :category="category"
          :isFirst="index == 0"
        >
          <template #default="{ item }">
            <HelpItem :item="item" />
          </template>
        </HelpCategory>
      </div>
    </sl-dropdown>
  </div>
</template>

<script setup lang="ts">
import { provide, useTemplateRef, watchEffect } from "vue";
import { helpMenuFunctionKey } from "@/shared/model/Menu";
import { SlDropdown } from "@shoelace-style/shoelace";
import { useCustomTeamBrain } from "@/shared/lib/useCustomTeamBrain";
import { PhQuestion } from "@phosphor-icons/vue";
import { HelpCategory as HelpCategoryType } from "@/features/helpMenu/model/HelpCategory";
import Trigger from "@/shared/ui/Trigger.vue";
import HelpCategory from "./HelpCategory.vue";
import HelpItem from "./HelpItem.vue";
import { integrateWithToken } from "@/shared/lib/cobbai";

const {
  helpMenu = [],
  teamBrainUrl = "",
  baseUrl = "",
  cobbaiChatId = "",
} = defineProps<{
  helpMenu: Array<HelpCategoryType>;
  teamBrainUrl: string;
  baseUrl?: string;
  cobbaiChatId?: string;
}>();

const dropdown = useTemplateRef<SlDropdown>("dropdownMenu");

const { activate, initTeamBrain } = useCustomTeamBrain();
watchEffect(() => initTeamBrain(teamBrainUrl));

provide(helpMenuFunctionKey, {
  teambrain: () => {
    dropdown.value?.hide();
    if (cobbaiChatId.length > 0) {
      integrateWithToken(baseUrl, cobbaiChatId);
    } else {
      activate();
    }
  },
});
</script>
